import { render } from "./RankingStateBlock.vue?vue&type=template&id=1ba5e8ca&scoped=true"
import script from "./RankingStateBlock.vue?vue&type=script&lang=js"
export * from "./RankingStateBlock.vue?vue&type=script&lang=js"

import "./RankingStateBlock.vue?vue&type=style&index=0&id=1ba5e8ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba5e8ca"]])

export default __exports__